import { useEffect, useState } from "react";
import axios from "axios";
import AppConst from "../apis/appconst";
import { toast } from 'react-toastify';

function Config() {
  const [activeTab, setActiveTab] = useState("IPD");

  const [formData, setFormData] = useState({
    IPD: { config_header: '', config_footer: '', config_logo: '' },
    OPD: { config_header: '', config_footer: '', config_logo: '' },
    LAB: { config_header: '', config_footer: '', config_logo: '' },
    Pharmacy: { config_header: '', config_footer: '', config_logo: '' },
    alertMsg: '',
    alertMsgTyp: '',
    isAlert: false,
  });

  const [preview, setPreview] = useState({
    config_header: null,
    config_footer: null,
    config_logo: null,
  });

  const [ldata, setLdata] = useState(null);

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        [activeTab]: {
          ...prev[activeTab],
          [type]: file,
        },
      }));

      setPreview((prev) => ({
        ...prev,
        [type]: URL.createObjectURL(file),
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const currentData = formData[activeTab];
    const fd = new FormData();
    fd.append("config_type", activeTab.toLowerCase());
    fd.append("logo", currentData.config_logo);
    fd.append("header_logo", currentData.config_header);
    fd.append("footer_logo", currentData.config_footer);

    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.upconfigUrl, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.status) {
        setFormData((prev) => ({
          ...prev,
          isAlert: true,
          alertMsg: response.data.success,
          alertMsgTyp: response.data.type,
        }));
        fetchConfigData(activeTab);
        toast.success("Updated successfully");

      } else {
        setFormData((prev) => ({
          ...prev,
          isAlert: true,
          alertMsg: response.data.success,
          alertMsgTyp: response.data.type,
        }));
        toast.error("Update failed");
      }
    } catch (error) {
      setFormData((prev) => ({
        ...prev,
        isAlert: true,
        alertMsg: "Failed",
        alertMsgTyp: "danger",
      }));
      console.error("Error updating config:", error);
      toast.error("Failed to update configuration");
    }
  };

  const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
    }
  };

  const fetchConfigData = async (tab) => {
    try {
      const res = await axios.post(
        `${AppConst.BASE_URL + AppConst.getconfig}?config_type=${tab.toLowerCase()}`
      );

      if (res.data.status) {
        const data = res.data;

     
        setPreview({
          config_header: data.header_logo,
          config_footer:  data.footer_logo,
          config_logo:   data.logo,
        });


        setFormData((prev) => ({
          ...prev,
          [tab]: {
            config_header: null,
            config_footer: null,
            config_logo: null,
          },
        }));
      }
    } catch (err) {
      console.error("Error fetching config:", err);
    }
  };

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    if (ldata?.user_id) {
      fetchConfigData(activeTab);
    }
  }, [ldata, activeTab]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xxl-12">
            <div className="card">
              <div className="card-body">
                <h5>Configuration Details</h5>
                <br />

                {/* CATEGORY BUTTONS */}
                <div className="mb-4">
                  {["IPD", "OPD", "LAB", "Pharmacy"].map((tab) => (
                    <button
                      key={tab}
                      type="button"
                      className={`btn btn-${activeTab === tab ? "primary" : "outline-primary"} me-2`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </button>
                  ))}
                </div>

                {/* FORM */}
                <div className="live-preview">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Upload Header</label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={(e) => handleFileChange(e, "config_header")}
                          />
                          {preview.config_header && (
                            <img
                              src={preview.config_header}
                              alt="Header Preview"
                              className="mt-2"
                              height={50}
                            />
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Upload Footer</label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={(e) => handleFileChange(e, "config_footer")}
                          />
                          {preview.config_footer && (
                            <img
                              src={preview.config_footer}
                              alt="Footer Preview"
                              className="mt-2"
                              height={50}
                            />
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Upload Logo</label>
                          <input
                            type="file"
                            className="form-control"
                            onChange={(e) => handleFileChange(e, "config_logo")}
                          />
                          {preview.config_logo && (
                            <img
                              src={preview.config_logo}
                              alt="Logo Preview"
                              className="mt-2"
                              height={50}
                            />
                          )}
                        </div>
                      </div>

                      <div className="col-lg-12 text-end">
                        <button type="submit" className="btn btn-primary">
                          Submit {activeTab}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                {/* ALERT */}
                {formData.isAlert && (
                  <div className={`alert alert-${formData.alertMsgTyp} mt-3`}>
                    {formData.alertMsg}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Config;
